import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Auth0UiService } from 'avn/services/auth0-serv.service';

import { BusinessMain, Location } from '../../../interfaces/homepage';
import { StoreService } from '../../../services/store.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  constructor(
    private store: StoreService,
    private auth0: Auth0UiService,
    @Inject(DOCUMENT) private dom: any,
    @Inject(PLATFORM_ID) private platformId: any,
    private router: Router
  ) {
    this.auth0.loginCheck('/');
  }

  @ViewChild('wellbeingScroll') wellbeingScroll: ElementRef;

  meraLocation = new Location();
  searchServices: BusinessMain[] = [];

  loading = true;
  fetching = false;
  todayDate = '';

  documentSize = 0;

  checkUserLogin: any;

  @HostListener('window:resize')
  onResize() {
    this.documentSize = this.dom.getElementById('m-body')?.clientWidth || 0;
  }

  ngOnInit(): void {
    this.onResize();
    if (isPlatformBrowser(this.platformId)) {
      this.store.meraLocationSub.subscribe((location: Location) => {
        this.meraLocation = location;
        const claim_number = localStorage.getItem('claim_number');
        const service = localStorage.getItem('service') || 'health-and-wellbeing-services';
        this.router.navigate(
          [
            `/search/${service}/${(this.meraLocation.city_name || 'sydney')?.toLowerCase()}/${
              this.meraLocation.post_code || '2000'
            }`
          ],
          {
            queryParams: {
              claim_number
            }
          }
        );
      });
    }
  }
}
